import { observer } from 'mobx-react-lite'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import type { ValueType, NameType, Formatter } from 'recharts/types/component/DefaultTooltipContent'
import { formatSecondsToLargestUnit } from 'shared/lib/dayjs'
import { PERFORMANCE_METRICS_CONFIG } from 'entities/Analytics/lib/constants'
import { type PerformanceChartDataStore } from 'pages/analytics/pages/performance/ui/Chart/store/performanceChartDataStore'
import styles from '../styles.module.scss'

interface PerformanceBarChartProps {
  chartDataStore: PerformanceChartDataStore
  hiddenMetrics?: Set<string>
}

export const PerformanceBarChart = observer(
  ({ chartDataStore, hiddenMetrics = new Set() }: PerformanceBarChartProps) => {
    const { rechartsData } = chartDataStore

    const formatYAxisTick = (value: number) => formatSecondsToLargestUnit(value)
    const formatTooltipValue: Formatter<ValueType, NameType> = (value, name) => [
      formatSecondsToLargestUnit(Number(value ?? 0)),
      String(name),
    ]

    return (
      <div className={styles.chartContainer}>
        <ResponsiveContainer width='100%' height={300}>
          <BarChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <CartesianGrid vertical horizontal={false} strokeDasharray={'5'} />
            <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
            <YAxis tickFormatter={formatYAxisTick} />
            <Tooltip cursor={false} formatter={formatTooltipValue} />
            {Object.entries(PERFORMANCE_METRICS_CONFIG).map(([key, config]) => {
              if (hiddenMetrics.has(key)) return null

              return (
                <Bar key={key} dataKey={key} fill={config.color} name={config.name} radius={6} />
              )
            })}
          </BarChart>
        </ResponsiveContainer>
      </div>
    )
  }
)
